import $ from "jquery";

const interpolateBackground = (el) => {
    const $el = $(el);
    const $wrapper = $el.find(".hero__wrap");
    const originalColor = $el.css("background-color"); // Get the original background color
    const sectionStart = $wrapper.offset().top + 100;
    const sectionEnd = sectionStart + $wrapper.height() / 4;
    const $pagination = $el.find(".hero__pagination__dot");

    $(window).on("scroll", function () {
        const scrollTop = $(window).scrollTop();
        if (scrollTop === 0) {
            $el.css("background-color", originalColor);
        } else if (scrollTop >= sectionStart && scrollTop <= sectionEnd) {
            const scrollPercentage =
                (scrollTop - sectionStart) / (sectionEnd - sectionStart);
            const newColor = interpolateColor(
                originalColor,
                "rgb(255, 255, 255)",
                scrollPercentage,
            ); // Interpolating between the original color and white
            const newPaginationColor = interpolateColor(
                "rgb(255, 255, 255)",
                "rgb(225, 235, 239)",
                scrollPercentage,
            ); // Interpolating between the original color and black
            $el.css("background-color", newColor);
            $pagination.css("background-color", newPaginationColor);
        }
    });
};

function interpolateColor(color1, color2, factor) {
    const rgb1 = color1.match(/\d+/g).map(Number);
    const rgb2 = color2.match(/\d+/g).map(Number);

    const r = Math.round(rgb1[0] + factor * (rgb2[0] - rgb1[0]));
    const g = Math.round(rgb1[1] + factor * (rgb2[1] - rgb1[1]));
    const b = Math.round(rgb1[2] + factor * (rgb2[2] - rgb1[2]));

    return `rgb(${r}, ${g}, ${b})`;
}
export default interpolateBackground;
